import React from "react";
import { Auth } from "aws-amplify";

import appleLogo from "assets/images/signin/apple.png";
import googleLogo from "assets/images/signin/google.png";
import amazonLogo from "assets/images/signin/amazon.png";
import facebookLogo from "assets/images/signin/facebook.png";
import microsoftLogo from "assets/images/signin/microsoft.png";
import emailLogo from "assets/images/signin/email.png";
import { loginRequest } from "shared/components/msal/msalConfig";

const SignInWays = ({ instance, handleEmailSignUp = () => {} }) => {
  const handleSignIn = (service) => {
    service === "email"
      ? handleEmailSignUp()
      : service === "Microsoft"
      ? instance.loginRedirect(loginRequest).catch((e) => {
          console.log(e, "eeeeeeeee");
        })
      : Auth.federatedSignIn({
          provider: service
        });
  };

  const Element = ({ logo, text, provider }) => {
    return (
      <div onClick={() => handleSignIn(provider)} className="signin-element">
        <div>
          <img alt="" src={logo} className="logo" />
        </div>
        <h2 className="text">{text}</h2>
        <div></div>
      </div>
    );
  };

  return (
    <div className="signin-ways">
      <Element logo={googleLogo} provider="Google" text="Google" />
      <Element logo={appleLogo} provider="SignInWithApple" text="Apple" />
      <Element logo={microsoftLogo} provider="Microsoft" text="Microsoft" />
      <Element logo={amazonLogo} provider="LoginWithAmazon" text="Amazon" />
      <Element logo={facebookLogo} provider="Facebook" text="Facebook" />
      <Element logo={emailLogo} provider="email" text="Use Email" />
    </div>
  );
};

export default SignInWays;
